<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-sm p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						강좌 만들기
					</h2>
					<span class="close" @click="$emit('close')">&times;</span>
				</div>
				<div class="modal-body p-10 clearfix">
					<router-link to="/classes/register" class="btn lg-btn half-width center-block round m-t-30 m-b-15">새 강좌 만들기</router-link>
					<router-link to="/classes/register?copy=true" class="btn lg-btn half-width center-block round">기존 강좌 복사하기</router-link>
				</div>
				<div class="modal-footer p-10 clearfix">
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalNewClass",

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>